"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _swiftInputOtpStyle = require("./swift-input-otp-style");
var _swiftLabel = _interopRequireDefault(require("./swift-label"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["placeholder", "separator", "isLastChild", "focus", "isDisabled", "hasErrored", "errorStyle", "focusStyle", "disabledStyle", "shouldAutoFocus", "isInputNum", "index", "value", "className", "isInputSecure"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// keyCode constants
var BACKSPACE = 8;
var LEFT_ARROW = 37;
var RIGHT_ARROW = 39;
var DELETE = 46;
var SPACEBAR = 32;

// Doesn't really check if it's a style Object
// Basic implementation to check if it's not a string
// of classNames and is an Object
// TODO: Better implementation
var isStyleObject = function isStyleObject(obj) {
  return (0, _typeof2.default)(obj) === "object";
};
var SingleOtpInput = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(SingleOtpInput, _PureComponent);
  var _super = _createSuper(SingleOtpInput);
  function SingleOtpInput(props) {
    var _this;
    (0, _classCallCheck2.default)(this, SingleOtpInput);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getClasses", function () {
      for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
        classes[_key] = arguments[_key];
      }
      return classes.filter(function (c) {
        return !isStyleObject(c) && c !== false;
      }).join(" ");
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getType", function () {
      var _this$props = _this.props,
        isInputSecure = _this$props.isInputSecure,
        isInputNum = _this$props.isInputNum;
      if (isInputSecure) {
        return "password";
      }
      if (isInputNum) {
        return "tel";
      }
      return "text";
    });
    _this.input = /*#__PURE__*/(0, _react.createRef)();
    return _this;
  }

  // Focus on first render
  // Only when shouldAutoFocus is true
  (0, _createClass2.default)(SingleOtpInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
        focus = _this$props2.focus,
        shouldAutoFocus = _this$props2.shouldAutoFocus;
      var inputEl = this.input.current;
      if (inputEl && focus && shouldAutoFocus) {
        inputEl.focus();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var focus = this.props.focus;
      var inputEl = this.input.current;

      // Check if focusedInput changed
      // Prevent calling function if input already in focus
      if (prevProps.focus !== focus && inputEl && focus) {
        inputEl.focus();
        inputEl.select();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        placeholder = _this$props3.placeholder,
        separator = _this$props3.separator,
        isLastChild = _this$props3.isLastChild,
        focus = _this$props3.focus,
        isDisabled = _this$props3.isDisabled,
        hasErrored = _this$props3.hasErrored,
        errorStyle = _this$props3.errorStyle,
        focusStyle = _this$props3.focusStyle,
        disabledStyle = _this$props3.disabledStyle,
        shouldAutoFocus = _this$props3.shouldAutoFocus,
        isInputNum = _this$props3.isInputNum,
        index = _this$props3.index,
        value = _this$props3.value,
        className = _this$props3.className,
        isInputSecure = _this$props3.isInputSecure,
        rest = (0, _objectWithoutProperties2.default)(_this$props3, _excluded);
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: className,
        style: {
          display: "flex",
          alignItems: "center"
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", _objectSpread({
          "aria-label": "".concat(index === 0 ? "Please enter verification code. " : "").concat(isInputNum ? "Digit" : "Character", " ").concat(index + 1),
          autoComplete: "off",
          style: Object.assign(focus && isStyleObject(focusStyle) && focusStyle, isDisabled && isStyleObject(disabledStyle) && disabledStyle, hasErrored && isStyleObject(errorStyle) && errorStyle),
          placeholder: placeholder,
          className: this.getClasses(focus && focusStyle, isDisabled && disabledStyle, hasErrored && errorStyle),
          type: this.getType(),
          maxLength: "1",
          ref: this.input,
          disabled: isDisabled,
          value: value ? value : ""
        }, rest)), !isLastChild && separator]
      });
    }
  }]);
  return SingleOtpInput;
}(_react.PureComponent);
var SwiftInputOTP = function SwiftInputOTP(props) {
  // useEffect(() => {
  //   console.log("props.fieldRef", props.fieldRef)
  //   if (props.autoFocus && props.fieldRef) props.fieldRef?.current?.focus()
  // }, [])

  var myRefs = props.myRefs;
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    activeInput = _useState2[0],
    setActiveInput = _useState2[1];
  var getOtpValue = function getOtpValue() {
    return props.value ? props.value.toString().split("") : [];
  };
  var getPlaceholderValue = function getPlaceholderValue() {
    var placeholder = props.placeholder,
      numInputs = props.numInputs;
    if (typeof placeholder === "string") {
      if (placeholder.length === numInputs) {
        return placeholder;
      }
      if (placeholder.length > 0) {
        console.error("Length of the placeholder should be equal to the number of inputs.");
      }
    }
  };

  // Helper to return OTP from input
  var handleOtpChange = function handleOtpChange(otp) {
    var onChange = props.onChange;
    var otpValue = otp.join("");
    onChange(otpValue);
  };
  var isInputValueValid = function isInputValueValid(value) {
    var isTypeValid = props.isInputNum ? !isNaN(parseInt(value, 10)) : typeof value === "string";
    return isTypeValid && value.trim().length === 1;
  };

  // Focus on input by index
  var focusInput = function focusInput(input) {
    var numInputs = props.numInputs;
    var activeInput = Math.max(Math.min(numInputs - 1, input), 0);
    setActiveInput(activeInput);
  };

  // Focus on next input
  var focusNextInput = function focusNextInput() {
    focusInput(activeInput + 1);
  };

  // Focus on previous input
  var focusPrevInput = function focusPrevInput() {
    focusInput(activeInput - 1);
  };

  // Change OTP value at focused input
  var changeCodeAtFocus = function changeCodeAtFocus(value) {
    var otp = getOtpValue();
    otp[activeInput] = value[0];
    handleOtpChange(otp);
  };

  // Handle pasted OTP
  // const handleOnPaste = (e) => {
  //   e.preventDefault()

  //   const { activeInput } = this.state
  //   const { numInputs, isDisabled } = props

  //   if (isDisabled) {
  //     return
  //   }

  //   const otp = this.getOtpValue()
  //   let nextActiveInput = activeInput

  //   // Get pastedData in an array of max size (num of inputs - current position)
  //   const pastedData = e.clipboardData
  //     .getData('text/plain')
  //     .slice(0, numInputs - activeInput)
  //     .split('')

  //   // Paste data from focused input onwards
  //   for (let pos = 0; pos < numInputs; ++pos) {
  //     if (pos >= activeInput && pastedData.length > 0) {
  //       otp[pos] = pastedData.shift()
  //       nextActiveInput++
  //     }
  //   }

  //   this.setState({ activeInput: nextActiveInput }, () => {
  //     this.focusInput(nextActiveInput)
  //     this.handleOtpChange(otp)
  //   })
  // }

  var handleOnChange = function handleOnChange(e) {
    var value = e.target.value;
    if (isInputValueValid(value)) {
      changeCodeAtFocus(value);
    }
  };

  // Handle cases of backspace, delete, left arrow, right arrow, space
  var handleOnKeyDown = function handleOnKeyDown(e) {
    if (e.keyCode === BACKSPACE || e.key === "Backspace") {
      e.preventDefault();
      changeCodeAtFocus("");
      focusPrevInput();
    } else if (e.keyCode === DELETE || e.key === "Delete") {
      e.preventDefault();
      changeCodeAtFocus("");
    } else if (e.keyCode === LEFT_ARROW || e.key === "ArrowLeft") {
      e.preventDefault();
      focusPrevInput();
    } else if (e.keyCode === RIGHT_ARROW || e.key === "ArrowRight") {
      e.preventDefault();
      focusNextInput();
    } else if (e.keyCode === SPACEBAR || e.key === " " || e.key === "Spacebar" || e.key === "Space") {
      e.preventDefault();
    }
  };

  // The content may not have changed, but some input took place hence change the focus
  var handleOnInput = function handleOnInput(e) {
    if (isInputValueValid(e.target.value)) {
      focusNextInput();
    } else {
      // This is a workaround for dealing with keyCode "229 Unidentified" on Android.

      if (!props.isInputNum) {
        var nativeEvent = e.nativeEvent;
        if (nativeEvent.data === null && nativeEvent.inputType === "deleteContentBackward") {
          e.preventDefault();
          changeCodeAtFocus("");
          focusPrevInput();
        }
      }
    }
  };
  var renderInputs = function renderInputs() {
    var numInputs = props.numInputs,
      focusStyle = props.focusStyle,
      separator = props.separator,
      isDisabled = props.isDisabled,
      disabledStyle = props.disabledStyle,
      hasErrored = props.hasErrored,
      errorStyle = props.errorStyle,
      autoFocus = props.autoFocus,
      isInputNum = props.isInputNum,
      isInputSecure = props.isInputSecure,
      className = props.className;
    var inputs = [];
    var otp = getOtpValue();
    var placeholder = getPlaceholderValue();
    var dataCy = props["data-cy"];
    var dataTestId = props["data-testid"];
    var _loop = function _loop(i) {
      inputs.push( /*#__PURE__*/(0, _jsxRuntime.jsx)(SingleOtpInput, {
        placeholder: placeholder && placeholder[i],
        index: i,
        focus: activeInput === i,
        value: otp && otp[i],
        onChange: handleOnChange,
        onKeyDown: handleOnKeyDown,
        onInput: handleOnInput
        //onPaste={handleOnPaste}
        ,
        onFocus: function onFocus(e) {
          setActiveInput(i);
          e.target.select();
        },
        onBlur: function onBlur() {
          return setActiveInput(-1);
        },
        separator: separator,
        focusStyle: focusStyle,
        isLastChild: i === numInputs - 1,
        isDisabled: isDisabled,
        disabledStyle: disabledStyle,
        hasErrored: hasErrored,
        errorStyle: errorStyle,
        shouldAutoFocus: autoFocus,
        isInputNum: isInputNum,
        isInputSecure: isInputSecure,
        className: className,
        "data-cy": dataCy && "".concat(dataCy, "-").concat(i),
        "data-testid": dataTestId && "".concat(dataTestId, "-").concat(i)
      }, i));
    };
    for (var i = 0; i < numInputs; i++) {
      _loop(i);
    }
    return inputs;
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_swiftInputOtpStyle.SwiftInputOTPStyled, {
    error: props.error && props.helperText ? true : false,
    entered: props.value ? true : false,
    valuesCount: props.values ? props.values.length : 0,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_swiftLabel.default, {
      children: props.label
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "swift_input_otp_wrapper",
      children: renderInputs()
    }), props.error && props.helperText ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_swiftLabel.default, {
      error: true,
      children: props.helperText
    }) : null]
  });
};
SwiftInputOTP.defaultProps = {
  numInputs: 6,
  onChange: function onChange(otp) {},
  isDisabled: false,
  value: "",
  isInputSecure: false,
  autoFocus: false
};
var _default = SwiftInputOTP;
exports.default = _default;